var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarTodaycomponent = function SvgCalendarTodaycomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 2.5H12V1.167h-1.333V2.5H5.333V1.167H4V2.5h-.667c-.74 0-1.326.6-1.326 1.333L2 13.167c0 .733.593 1.333 1.333 1.333h9.334c.733 0 1.333-.6 1.333-1.333V3.833C14 3.1 13.4 2.5 12.667 2.5Zm0 3.333v7.334H3.333V5.833h9.334ZM8 7.167H4.667V10.5H8V7.167Z",
    fill: "current"
  })));
};
export default SvgCalendarTodaycomponent;